<template>
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    <title>Filter</title>
    <path
      fill="#679940"
      d="M27.699 3.4h-23.399c-0.004-0-0.010-0-0.015-0-0.34 0-0.634 0.196-0.775 0.481l-0.002 0.005c-0.084 0.133-0.134 0.294-0.134 0.468s0.050 0.335 0.136 0.472l-0.002-0.004 8.892 12.365v12.311c0.003 0.338 0.189 0.633 0.463 0.79l0.004 0.003c0.125 0.067 0.274 0.107 0.431 0.108h0.001c0.186-0.004 0.36-0.057 0.509-0.146l-0.005 0.003 5.4-3.6c0.24-0.168 0.396-0.443 0.396-0.755 0-0 0-0.001 0-0.001v0-8.712l8.838-12.365c0.084-0.133 0.134-0.294 0.134-0.468s-0.050-0.335-0.136-0.472l0.002 0.004c-0.138-0.279-0.414-0.471-0.736-0.486l-0.002-0zM17.962 16.378s0 0 0 0c-0.003 0.024-0.005 0.052-0.005 0.081s0.002 0.057 0.006 0.084l-0-0.003c-0.005 0.027-0.008 0.058-0.008 0.090s0.003 0.063 0.008 0.093l-0.001-0.003s0 0 0 0.090v8.514l-3.6 2.412v-10.835s0 0 0-0.090c0.005-0.027 0.008-0.058 0.008-0.090s-0.003-0.063-0.008-0.093l0.001 0.003c0.003-0.024 0.005-0.052 0.005-0.081s-0.002-0.057-0.005-0.084l0 0.003s0 0 0 0l-8.316-11.267h19.907z"
    />
  </svg>
</template>

<script>
export default {
  name: "FilterIcon"
};
</script>


// WEBPACK FOOTER //
// src/icons/FilterIcon.vue